'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChatHeadingConfig = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getChatHeadingConfig = exports.getChatHeadingConfig = (0, _getIn2.default)(['chatHeadingConfig']);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-schema/static-2.2846/js/operators/message/getChatHeadingConfig.js
// module id = 962
// module chunks = 2 3